export const ALL_COUNTRIES = [
  "Afghanistan", "Afrique du Sud", "Albanie", "Algérie", "Allemagne", "Andorre", "Angola",
  "Antigua-et-Barbuda", "Arabie saoudite", "Argentine", "Arménie", "Australie", "Autriche",
  "Azerbaïdjan", "Bahamas", "Bahreïn", "Bangladesh", "Barbade", "Belgique", "Belize", "Bénin",
  "Bhoutan", "Biélorussie", "Birmanie (Myanmar)", "Bolivie", "Bosnie-Herzégovine", "Botswana",
  "Brésil", "Brunei", "Bulgarie", "Burkina Faso", "Burundi", "Cambodge", "Cameroun", "Canada",
  "Cap-Vert", "Chili", "Chine", "Chypre", "Colombie", "Comores", "Congo (Brazzaville)",
  "Congo (RDC)", "Corée du Nord", "Corée du Sud", "Costa Rica", "Côte d'Ivoire", "Croatie",
  "Cuba", "Danemark", "Djibouti", "Dominique", "Égypte", "Émirats arabes unis", "Équateur",
  "Érythrée", "Espagne", "Estonie", "Eswatini", "États-Unis", "Éthiopie", "Fidji", "Finlande",
  "France", "Gabon", "Gambie", "Géorgie", "Ghana", "Grèce", "Grenade", "Guatemala", "Guinée",
  "Guinée équatoriale", "Guinée-Bissau", "Guyana", "Haïti", "Honduras", "Hongrie", "Îles Marshall",
  "Îles Salomon", "Inde", "Indonésie", "Irak", "Iran", "Irlande", "Islande", "Israël", "Italie",
  "Jamaïque", "Japon", "Jordanie", "Kazakhstan", "Kenya", "Kirghizistan", "Kiribati", "Kosovo",
  "Koweït", "Laos", "Lesotho", "Lettonie", "Liban", "Libéria", "Libye", "Liechtenstein",
  "Lituanie", "Luxembourg", "Macédoine du Nord", "Madagascar", "Malaisie", "Malawi", "Maldives",
  "Mali", "Malte", "Maroc", "Maurice", "Mauritanie", "Mexique", "Micronésie", "Moldavie", "Monaco",
  "Mongolie", "Monténégro", "Mozambique", "Namibie", "Nauru", "Népal", "Nicaragua", "Niger",
  "Nigéria", "Norvège", "Nouvelle-Zélande", "Oman", "Ouganda", "Ouzbékistan", "Pakistan", "Palaos",
  "Palestine", "Panama", "Papouasie-Nouvelle-Guinée", "Paraguay", "Pays-Bas", "Pérou",
  "Philippines", "Pologne", "Portugal", "Qatar", "République centrafricaine", "République dominicaine",
  "République tchèque", "Roumanie", "Royaume-Uni", "Russie", "Rwanda", "Saint-Kitts-et-Nevis",
  "Saint-Marin", "Saint-Vincent-et-les-Grenadines", "Sainte-Lucie", "Salvador", "Samoa",
  "Sao Tomé-et-Principe", "Sénégal", "Serbie", "Seychelles", "Sierra Leone", "Singapour",
  "Slovaquie", "Slovénie", "Somalie", "Soudan", "Soudan du Sud", "Sri Lanka", "Suède", "Suisse",
  "Suriname", "Syrie", "Tadjikistan", "Taïwan", "Tanzanie", "Tchad", "Thaïlande", "Timor oriental",
  "Togo", "Tonga", "Trinité-et-Tobago", "Tunisie", "Turkménistan", "Turquie", "Tuvalu", "Ukraine",
  "Uruguay", "Vanuatu", "Vatican", "Venezuela", "Viêt Nam", "Yémen", "Zambie", "Zimbabwe",
];

// English aliases so the search matches both French and English names (e.g. "Croatia" -> "Croatie").
export const COUNTRY_KEYWORDS = {
  "Afghanistan": "Afghanistan", "Afrique du Sud": "South Africa", "Albanie": "Albania",
  "Algérie": "Algeria", "Allemagne": "Germany Deutschland", "Andorre": "Andorra", "Angola": "Angola",
  "Antigua-et-Barbuda": "Antigua and Barbuda", "Arabie saoudite": "Saudi Arabia", "Argentine": "Argentina",
  "Arménie": "Armenia", "Australie": "Australia", "Autriche": "Austria", "Azerbaïdjan": "Azerbaijan",
  "Bahamas": "Bahamas", "Bahreïn": "Bahrain", "Bangladesh": "Bangladesh", "Barbade": "Barbados",
  "Belgique": "Belgium", "Belize": "Belize", "Bénin": "Benin", "Bhoutan": "Bhutan",
  "Biélorussie": "Belarus", "Birmanie (Myanmar)": "Myanmar Burma", "Bolivie": "Bolivia",
  "Bosnie-Herzégovine": "Bosnia and Herzegovina", "Botswana": "Botswana", "Brésil": "Brazil Brasil",
  "Brunei": "Brunei", "Bulgarie": "Bulgaria", "Burkina Faso": "Burkina Faso", "Burundi": "Burundi",
  "Cambodge": "Cambodia", "Cameroun": "Cameroon", "Canada": "Canada", "Cap-Vert": "Cape Verde Cabo Verde",
  "Chili": "Chile", "Chine": "China", "Chypre": "Cyprus", "Colombie": "Colombia", "Comores": "Comoros",
  "Congo (Brazzaville)": "Republic of the Congo", "Congo (RDC)": "Democratic Republic of the Congo DRC",
  "Corée du Nord": "North Korea", "Corée du Sud": "South Korea", "Costa Rica": "Costa Rica",
  "Côte d'Ivoire": "Ivory Coast Cote d'Ivoire", "Croatie": "Croatia Hrvatska", "Cuba": "Cuba",
  "Danemark": "Denmark", "Djibouti": "Djibouti", "Dominique": "Dominica", "Égypte": "Egypt",
  "Émirats arabes unis": "United Arab Emirates UAE", "Équateur": "Ecuador", "Érythrée": "Eritrea",
  "Espagne": "Spain España", "Estonie": "Estonia", "Eswatini": "Eswatini Swaziland",
  "États-Unis": "United States USA America", "Éthiopie": "Ethiopia", "Fidji": "Fiji", "Finlande": "Finland",
  "France": "France", "Gabon": "Gabon", "Gambie": "Gambia", "Géorgie": "Georgia", "Ghana": "Ghana",
  "Grèce": "Greece", "Grenade": "Grenada", "Guatemala": "Guatemala", "Guinée": "Guinea",
  "Guinée équatoriale": "Equatorial Guinea", "Guinée-Bissau": "Guinea-Bissau", "Guyana": "Guyana",
  "Haïti": "Haiti", "Honduras": "Honduras", "Hongrie": "Hungary", "Îles Marshall": "Marshall Islands",
  "Îles Salomon": "Solomon Islands", "Inde": "India", "Indonésie": "Indonesia", "Irak": "Iraq",
  "Iran": "Iran", "Irlande": "Ireland", "Islande": "Iceland", "Israël": "Israel", "Italie": "Italy Italia",
  "Jamaïque": "Jamaica", "Japon": "Japan", "Jordanie": "Jordan", "Kazakhstan": "Kazakhstan",
  "Kenya": "Kenya", "Kirghizistan": "Kyrgyzstan", "Kiribati": "Kiribati", "Kosovo": "Kosovo",
  "Koweït": "Kuwait", "Laos": "Laos", "Lesotho": "Lesotho", "Lettonie": "Latvia", "Liban": "Lebanon",
  "Libéria": "Liberia", "Libye": "Libya", "Liechtenstein": "Liechtenstein", "Lituanie": "Lithuania",
  "Luxembourg": "Luxembourg", "Macédoine du Nord": "North Macedonia", "Madagascar": "Madagascar",
  "Malaisie": "Malaysia", "Malawi": "Malawi", "Maldives": "Maldives", "Mali": "Mali", "Malte": "Malta",
  "Maroc": "Morocco", "Maurice": "Mauritius", "Mauritanie": "Mauritania", "Mexique": "Mexico",
  "Micronésie": "Micronesia", "Moldavie": "Moldova", "Monaco": "Monaco", "Mongolie": "Mongolia",
  "Monténégro": "Montenegro", "Mozambique": "Mozambique", "Namibie": "Namibia", "Nauru": "Nauru",
  "Népal": "Nepal", "Nicaragua": "Nicaragua", "Niger": "Niger", "Nigéria": "Nigeria", "Norvège": "Norway",
  "Nouvelle-Zélande": "New Zealand", "Oman": "Oman", "Ouganda": "Uganda", "Ouzbékistan": "Uzbekistan",
  "Pakistan": "Pakistan", "Palaos": "Palau", "Palestine": "Palestine", "Panama": "Panama",
  "Papouasie-Nouvelle-Guinée": "Papua New Guinea", "Paraguay": "Paraguay", "Pays-Bas": "Netherlands Holland",
  "Pérou": "Peru", "Philippines": "Philippines", "Pologne": "Poland", "Portugal": "Portugal",
  "Qatar": "Qatar", "République centrafricaine": "Central African Republic",
  "République dominicaine": "Dominican Republic", "République tchèque": "Czech Republic Czechia",
  "Roumanie": "Romania", "Royaume-Uni": "United Kingdom UK Britain England", "Russie": "Russia",
  "Rwanda": "Rwanda", "Saint-Kitts-et-Nevis": "Saint Kitts and Nevis", "Saint-Marin": "San Marino",
  "Saint-Vincent-et-les-Grenadines": "Saint Vincent and the Grenadines", "Sainte-Lucie": "Saint Lucia",
  "Salvador": "El Salvador", "Samoa": "Samoa", "Sao Tomé-et-Principe": "Sao Tome and Principe",
  "Sénégal": "Senegal", "Serbie": "Serbia", "Seychelles": "Seychelles", "Sierra Leone": "Sierra Leone",
  "Singapour": "Singapore", "Slovaquie": "Slovakia", "Slovénie": "Slovenia", "Somalie": "Somalia",
  "Soudan": "Sudan", "Soudan du Sud": "South Sudan", "Sri Lanka": "Sri Lanka", "Suède": "Sweden",
  "Suisse": "Switzerland Swiss", "Suriname": "Suriname", "Syrie": "Syria", "Tadjikistan": "Tajikistan",
  "Taïwan": "Taiwan", "Tanzanie": "Tanzania", "Tchad": "Chad", "Thaïlande": "Thailand",
  "Timor oriental": "East Timor Timor-Leste", "Togo": "Togo", "Tonga": "Tonga",
  "Trinité-et-Tobago": "Trinidad and Tobago", "Tunisie": "Tunisia", "Turkménistan": "Turkmenistan",
  "Turquie": "Turkey Türkiye", "Tuvalu": "Tuvalu", "Ukraine": "Ukraine", "Uruguay": "Uruguay",
  "Vanuatu": "Vanuatu", "Vatican": "Vatican Holy See", "Venezuela": "Venezuela",
  "Viêt Nam": "Vietnam", "Yémen": "Yemen", "Zambie": "Zambia", "Zimbabwe": "Zimbabwe",
};

export const COUNTRIES = [
  "France",
  "Espagne",
  "Portugal",
  "Suisse",
  "Italie",
  "Royaume-Uni",
  "Émirats arabes unis",
  "Maroc",
  "Grèce",
  "États-Unis",
];

export const PROPERTY_TYPES = [
  "Villa", "Appartement", "Chalet", "Immeuble", "Bureaux", "Terrain", "Hôtel",
  "Domaine", "Complexe hôtelier", "Resort hôtelier", "Résidence hôtelière", "Château",
  "Propriété de prestige", "Entrepôt", "Local commercial", "Centre commercial",
  "Logistique", "Terrain à développer",
];

export const OPP_STATUS = ["Active", "En négociation", "Signé"];

export const CONFIDENTIALITY = ["Standard", "Confidentiel", "Ultra-confidentiel"];

// Display labels only — stored DB values (keys) stay unchanged.
export const CONFIDENTIALITY_LABELS = {
  "Standard": "Public",
  "Confidentiel": "Confidentiel",
  "Ultra-confidentiel": "Ultra-confidentiel",
};

export const CURRENCIES = ["EUR", "USD", "CAD", "AUD", "AED", "TRY", "GBP", "CHF"];

export const INVESTOR_STATUS = ["Prospect", "En discussion", "Actif"];
